import { Permission } from 'domains/storefront/access-control/permissions'
import { Flipper } from 'domains/storefront/access-control/flippers'
import { type DomainAccessControlConfig } from 'domains/storefront/utils/domain/accessControl'

export const autosuggestAllAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestModify, Permission.AutosuggestView],
}

export const autosuggestViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestView],
  warehouseFlippers: Flipper.storefront,
}

export const autosuggestModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestModify],
  warehouseFlippers: Flipper.storefront,
}
